import { TeamsState } from '.';

export const selectTeams = (state: { teams: TeamsState }) => state.teams.teams ?? [];
export const selectGetTeamsStatus = (state: { teams: TeamsState }) => state.teams.getTeamsStatus;
export const selectGetTeamsErrorInfo = (state: { teams: TeamsState }) => state.teams.getTeamsError;
